import { AppUser } from 'Src/views/App/App';
import { DEFAULT_FILTER } from './user';
import axios from 'Src/helpers/api/axiosInstance';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from 'Src/consts/table';
import { Count } from '../../../models/count';
import { FormDefinition } from 'Src/types/formSchema';

export type ClubInviteExcludeItem = { userId: string; permissionId: string };

export type ClubInviteTextRule =
  | string
  | number
  | boolean
  | null
  | {
      like?: string;
      ilike?: string;
      regexp?: string;
      options?: string;
      $regex?: string;
      $options?: string;
      inq?: Array<string | number | boolean>;
    };

export type ClubInviteWhere =
  | {
      and?: ClubInviteWhere[];
      or?: ClubInviteWhere[];
      not?: ClubInviteWhere;

      firstName?: ClubInviteTextRule;
      lastName?: ClubInviteTextRule;

      participant?: boolean | 'true' | 'false' | 1 | 0 | '1' | '0';
    }
  | undefined;

export type SendClubMessagesPayload =
  | {
      selectAll?: false;
      participants: any[];
      deadlineForAnswers?: string | null;
      fields?: any[];
      formSchemaVersion?: 2;
      formDefinition?: FormDefinition;
    }
  | {
      selectAll: true;
      where?: ClubInviteWhere;
      exclude: ClubInviteExcludeItem[];
      deadlineForAnswers?: string | null;
      fields?: any[];
      formSchemaVersion?: 2;
      formDefinition?: FormDefinition;
    };

export function getClubMessages(user: AppUser, clubId: string, filter = DEFAULT_FILTER) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter
    }
  };

  return axios.get(`${window.apiBase}/i/schools/${activeSchoolId}/clubs/${clubId}/messages`, config).then(response => {
    return response.data;
  });
}

export function getAllClubMessages(user: AppUser, clubId: string, where?) {
  const { roleSessionKey: key, activeSchoolId } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where
          },
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP
        }
      }
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP
        }
      }
    };
  }

  return axios.get(`${window.apiBase}/i/schools/${activeSchoolId}/clubs/${clubId}/messages`, config).then(response => {
    return response.data;
  });
}

export function getClubMessagesCount(user: AppUser, clubId: string, where?): Promise<Count> {
  const { roleSessionKey: key, activeSchoolId } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: where
        }
      }
    };
  } else {
    config = {
      headers: { usid: key }
    };
  }

  return axios
    .get<Count>(`${window.apiBase}/i/schools/${activeSchoolId}/clubs/${clubId}/messages/count`, config)
    .then(response => {
      return response.data;
    });
}

export function sendClubMessages(user: AppUser, clubId: string, data: SendClubMessagesPayload) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  const isSelectAll =
    (data as any)?.selectAll === true ||
    (data as any)?.selectAll === 'true' ||
    (data as any)?.selectAll === 1 ||
    (data as any)?.selectAll === '1';

  const normalized: SendClubMessagesPayload = isSelectAll
    ? {
        selectAll: true,
        where: (data as any).where,
        exclude: Array.isArray((data as any).exclude) ? (data as any).exclude : [],
        deadlineForAnswers: (data as any).deadlineForAnswers,
        fields: (data as any).fields,
        formSchemaVersion: (data as any).formSchemaVersion,
        formDefinition: (data as any).formDefinition
      }
    : data;

  return axios
    .post(`${window.apiBase}/i/schools/${activeSchoolId}/clubs/${clubId}/messages/invite`, normalized, config)
    .then(r => r.data);
}
